"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const paragraphs = ["Imaginez un matin sans logistique, où votre seule mission est de vous imprégner de ces précieux moments avec votre nouveau-né, sans la pression de « gérer la maison ». Je m’occupe du reste.", "J’aide à créer l’espace nécessaire pour ralentir vraiment, afin que votre récupération ne devienne pas un défi de plus à relever, mais une transition plus douce et plus soutenue.", "Je suis là pour atténuer le bruit du monde extérieur et vous permettre de vous recharger — physiquement et émotionnellement — afin que vous puissiez retrouver progressivement votre énergie avec un sentiment renouvelé de calme et d’équilibre."];
export default function Imaginez() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}